/**
 * Die Kalenderkachel (Spec 46c, Entscheidung 5; Design-System „Dritte
 * Ausnahme … Fristen"): 44 px breit, oben ein Monatsband in der Statusfarbe,
 * darunter der Tag. Sie ersetzt in Fristzeilen den 3-px-Rand und den Punkt —
 * das Datum steht selbst da, die Farbe ist nie das einzige Signal.
 *
 * **Kein Fachbegriff, keine Datumslogik.** Monat („NOV") und Tag („30") kommen
 * fertig vom Server (`month_tile_display`, `day_tile_display`); der Aufrufer
 * liefert auch den Bezeichner. Die Kachel ist dekorativ (`aria-hidden`), die
 * Zeile darum liest den Text — Bauform `ProgressEdgeLine` auf iOS.
 */

interface DateTileProps {
  readonly month: string
  readonly day: string
  readonly testId: string
}

export function DateTile({ month, day, testId }: DateTileProps) {
  return (
    <span
      data-testid={testId}
      aria-hidden="true"
      className="border-border bg-surface rounded-card flex w-11 shrink-0 flex-col overflow-hidden border text-center"
    >
      <span className="bg-status-partial-text text-label text-surface py-px font-bold uppercase">{month}</span>
      <span className="text-section text-text py-0.5 font-semibold tabular-nums">
        {day}
      </span>
    </span>
  )
}
